import { LineItemKey } from '../../store/api';

/**
 * STATE TYPES
 */
export type ProductSelection = IncludeProductSelection | ExcludeProductSelection | undefined;
export type IncludeProductSelection = {
    included: LineItemKey[];
};
export type ExcludeProductSelection = {
    excluded: LineItemKey[];
    totalCount: number;
};
export const isIncludeProductSelection = (context: ProductSelection): context is IncludeProductSelection => {
    return !!context && !!(context as IncludeProductSelection).included;
};
export const isExcludeProductSelection = (context: ProductSelection): context is ExcludeProductSelection => {
    return !!context && !!(context as ExcludeProductSelection).excluded;
};

/**
 * ACTION TYPES
 */
export enum ProductSelectionAction {
    INIT_INCLUDE_SELECTION = 'INIT_INCLUDE_SELECTION',
    INIT_EXCLUDE_SELECTION = 'INIT_EXCLUDE_SELECTION',
    TOGGLE_KEY = 'TOGGLE_KEY',
    CLOSE = 'CLOSE'
}

export type ProductSelectionActions = InitIncludeSelection | InitExcludeSelection | ToggleKey | Close;
export type InitIncludeSelection = {
    type: ProductSelectionAction.INIT_INCLUDE_SELECTION;
};
export type InitExcludeSelection = {
    type: ProductSelectionAction.INIT_EXCLUDE_SELECTION;
    totalCount: number;
};
export type ToggleKey = {
    type: typeof ProductSelectionAction.TOGGLE_KEY;
    key: LineItemKey;
};
export type Close = {
    type: typeof ProductSelectionAction.CLOSE;
};
